import { DataSource, Label, Layout, Panel, Switch, Table } from "@mcleod/components";

export abstract class AutogenLayoutMovementRollback extends Layout {
    labelDetentionText: Label;
    labelInstructAll: Label;
    labelInstructEmpty: Label;
    labelInstructPartial: Label;
    labelLocateInfo: Label;
    labelWarnings: Label;
    panelInstructions: Panel;
    panelOptions: Panel;
    panelStops: Panel;
    panelWarnings: Panel;
    panelWarningsContainer: Panel;
    sourceStop: DataSource;
    sourceUnclearStops: DataSource;
    switchLeaveChassis: Switch;
    switchLeaveTractor: Switch;
    switchLeaveTrailer: Switch;
    switchYSplit: Switch;
    tableStops: Table;
}
